import ShapeElement from './ShapeElement';
import ShapeElementDefinition from './ShapeElementDefinition';
import ShapeElementMetaData from './ShapeElementMetaData';

export default {
  ShapeElement: ShapeElement,
  ShapeElementDefinition: ShapeElementDefinition,
  ShapeElementType: ShapeElementMetaData.type
};
